import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { validateAssistedSalesCouponFetcher } from '@api/fetcher/ambassdor'

type Props = {
    data: any
    isLoading: boolean
    error: unknown
    mutate: UseMutationResult['mutate']
}

const useValidateAssistedSalesCoupon = (): Props => {
    const { data, isLoading, mutate, error } = useMutation(
        ['validate-assisted-sales-coupon'],
        validateAssistedSalesCouponFetcher
    )

    return {
        data,
        isLoading,
        error,
        mutate,
    }
}
export default useValidateAssistedSalesCoupon
